import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';

const ResolvePagingParams: ResolveFn<any> = (route: ActivatedRouteSnapshot) => {
  const page = parseInt(route.queryParams.page ?? '1', 10);
  const defaultSort = route.data.defaultSort ?? 'id,asc';
  const sort = route.queryParams.sort ?? defaultSort;
  return {
    page,
    predicate: sort.split(',')[0],
    ascending: sort.split(',')[1] === 'asc'
  };
};
export default ResolvePagingParams;
